import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getManagement, InfoResult } from "generated/api/management";
import { managementKeys } from "./query-keys";

export const useManagementInfo = (
  options?: Omit<
    UseQueryOptions<InfoResult, Error, InfoResult>,
    "queryKey" | "queryFn"
  >,
) => {
  const api = getManagement();
  return useQuery({
    queryKey: managementKeys.info(),
    queryFn: () => api.info(),
    // This is build metadata; avoid spammy refetches when LoginPage remounts.
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    retry: 0,
    ...options,
  });
};
